<template>
  <section class="px-2 xl:px-8 flex items-center justify-center" v-if="images">
    <button
      @click="prevSlide"
      v-html="'&lt;'"
      class="text-white text-2xl font-bold font-russo"
    ></button>
    <div class="flex gap-2 overflow-hidden">
      <transition name="slide" mode="out-in">
        <div
          class="md:gap-2 xl:gap-8 px-2 xl:px-8 grid grid-cols-1 md:grid-cols-4 transition-transform duration-500 ease-in-out h-[20vh] min-h-[200px] items-center"
          :key="startIndex"
        >
          <img
            v-for="(image, index) in visibleImages"
            :key="startIndex + index"
            :src="image"
            :alt="'Image ' + index"
            class="w-full object-fill flex col-span-1"
          />
        </div>
      </transition>
    </div>
    <button
      @click="nextSlide"
      :disabled="startIndex + 4 >= images.length"
      v-html="'&gt;'"
      class="text-white text-2xl font-bold font-russo"
    ></button>
  </section>
</template>

<script>
export default {
  name: 'EventsBanner',
  data() {
    return {
      startIndex: 0,
      timer: null,
    };
  },
  props: {
    images: Array,
  },
  computed: {
    visibleImages() {
      return this.images.slice(
        this.startIndex,
        this.startIndex + (window.innerWidth <= 768 ? 1 : 4)
      );
    },
  },
  methods: {
    nextSlide() {
      if (window.innerWidth <= 768) {
        if (this.startIndex + 1 < this.images.length) {
          this.startIndex += 1;
        }
      } else {
        if (this.startIndex + 4 < this.images.length) {
          this.startIndex += 4;
        }
      }
    },
    prevSlide() {
      if (window.innerWidth <= 768) {
        if (this.startIndex > 0) {
          this.startIndex -= 1;
        }
      } else {
        if (this.startIndex > 0) {
          this.startIndex -= 4;
        }
      }
    },
  },
  mounted() {
    this.timer = setInterval(this.nextSlide, 5000);
  },
  beforeUnmount() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped></style>
